import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Grid, GridColumn, GridDetailRow, GridToolbar } from '@progress/kendo-react-grid';
import './RFQ.scss';

import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

class RFQMaterilaDetailsComponent extends GridDetailRow {

    constructor(){
        super();
       this.state = {
        childDataFiltered : []
// dataItem :this.props.dataItem
        };
    }
   
  componentDidMount(){
    const dataItem = this.props.dataItem;
    var dataTopush = [];
    for(var i=0; i<dataItem.childData.length;i++)
			{
				if(dataItem.childData[i].ITEM_PARENT_KEY==dataItem.DB_KEY)
				{
                  
                    dataTopush.push(dataItem.childData[i])
					// this.state.childDataFiltered.push(tempJson);
                   
				}
  }
  this.setState({childDataFiltered : dataTopush});
} 
        render() {
            

            const grid = (

                <Grid
               
                    ScrollMode="scrollable"
                    data = {this.state.childDataFiltered}
                    ref={(grid) => { this._grid = grid; }}
                   
               
               
        
                >
                     <GridColumn field="PRODUCT_ID" title="Material ID"  width="320px" />    
                    <GridColumn field="ITEM_DESCR" title="Material Description"  width="350px"   /> 
                        
                    <GridColumn field="AMT_GDSV_VAL" title="Material Value" width="450px" />
                    <GridColumn field="AMT_GDSV_CUR" title="Currency"   width="460px"  />             
                     
                         
                     
                   
                </Grid>
            );
           
            
            return (
                <div>
                    
                  
                   {grid}
                </div>
            );
        }
    
}

export default RFQMaterilaDetailsComponent;